import React, { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

import { COLORS, StatusBanner } from "components";
import { JOBS_PAGE } from "pages/authenticated/jobs/consts";

export const WarningAlert = () => (
  <StatusBanner variant="warning">
    <strong>Large number of bills selected.</strong> This process may take a
    while. Consider narrowing your filters to reduce the scope.
  </StatusBanner>
);

export const InfoAlert = ({ children }: { children?: ReactNode }) => (
  <StatusBanner variant="info">
    {children ?? (
      <>
        Emissions will be recalculated for all eligible bills matching the
        current filters. <strong>This action cannot be undone.</strong>
      </>
    )}
  </StatusBanner>
);

export const BlockedAlert = () => (
  <StatusBanner variant="caution">
    <strong>A recalculation is already in progress.</strong> Please wait for it
    to finish before starting a new one. Track progress in the{" "}
    <RouterLink
      to={JOBS_PAGE.ABSOLUTE_PATH}
      target="_blank"
      style={{ color: COLORS.Mainblue, fontWeight: 500 }}
    >
      Jobs page
    </RouterLink>
    .
  </StatusBanner>
);
